/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import { getForm } from '../../../../utils/reducerHalpers/formFields';
import { createReducerDotPathName } from './naming';

const getState = (state, reducerName) =>
  _.get(state, createReducerDotPathName(reducerName));

export const selectState = (state, reducerName) => getState(state, reducerName);

export const selectFormBody = (state, reducerName) =>
  getForm(getState(state, reducerName));

export const selectFieldSum = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.sum');

export const selectFieldOutputAccountsType = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.payout_accounts_type');

export const selectFieldAccountNumber = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.account_number');

export const selectOutputSumFromCommission = (state, reducerName) => {
  const sumValue = _.get(getState(state, reducerName), 'fields.sum.value');
  const commission = _.get(getState(state, reducerName), 'commission');
  if (sumValue === 0 || !sumValue) {
    return 0;
  }

  const preSum = sumValue - commission.fixedCharge;
  // const result = preSum / (1 + commission.totalCommission / 100);
  // return result >= 0 ? Math.round(result * 100) / 100 : 0;
  const result = preSum - (preSum * commission.totalCommission) / 100;
  return result >= 0 ? Math.floor(result * 100) / 100 : 0;
};

export const selectResultObject = (state, reducerName) =>
  _.get(getState(state, reducerName), 'resultObject');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputCashFrom/selectors.js